<!-- Date Range Picker (optional) -->
<div *ngIf="showDateRange" [class]="dateRangeColClass">
  <mat-form-field class="full-width-field">
    <mat-label>Date Range</mat-label>
    <input #dateRangeInput matInput
      [value]="dateRangeDisplayValue"
      placeholder="Select date range"
      readonly
      name="dateRange">
    <button matSuffix mat-icon-button type="button" (click)="openDateRangePicker()">
      <mat-icon>calendar_today</mat-icon>
    </button>
  </mat-form-field>
</div>

<!-- Week Dropdown -->
<div [class]="weekColClass">
  <mat-form-field class="full-width-field">
    <mat-label>Week</mat-label>
    <mat-select
      [ngModel]="week"
      name="week"
      (selectionChange)="onWeekChange($event)"
      [disabled]="isDateRangeActive">
      <mat-option *ngIf="showNoneOption">None</mat-option>
      <mat-option *ngFor="let element of WeeksForYearData" [value]="element.key">
        {{ element.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- Year Dropdown -->
<div [class]="yearColClass">
  <mat-form-field class="full-width-field">
    <mat-label>Year</mat-label>
    <mat-select
      [ngModel]="year"
      name="year"
      (selectionChange)="onYearChange($event)"
      [disabled]="isDateRangeActive">
      <mat-option *ngIf="showNoneOption">None</mat-option>
      <mat-option *ngFor="let element of LastFourYearsData" [value]="element.key">
        {{ element.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
